import React from 'react';

import style from './SpeedControl.css';

const maxAllowableSpeed = 2048;
const minAllowableSpeed = 1;

function reduceSpeed(setClockSpeed, speed) {
  setClockSpeed(Math.max(speed * 0.5, minAllowableSpeed));
}

function increaseSpeed(setClockSpeed, speed) {
  setClockSpeed(Math.min(speed * 2, maxAllowableSpeed));
}

function getName(isFinished, playing) {
  if (isFinished) return <ReplaySvg />;
  else if (playing) return <PauseSvg />;
  else return <PlaySvg />;
}

const PlayButton = ({ onPlayClick, playing, finished, isMobile }) => (
  <div
    className={`${isMobile ? style.mobile : ''} ${style.button} ${style.playButton}`}
    onClick={() => onPlayClick(finished)}
  >
    {getName(finished, playing)}
  </div>
);

const Minus = ({ setClockSpeed, speed, isMobile }) => (
  <div
    className={`${isMobile ? style.mobile : ''} ${style.button} ${style.button}`}
    onClick={() => reduceSpeed(setClockSpeed, speed)}
  >
    <SpeedDownSvg />
  </div>
);

const Plus = ({ setClockSpeed, speed, isMobile }) => (
  <div
    className={`${isMobile ? style.mobile : ''} ${style.button} ${style.button}`}
    onClick={() => increaseSpeed(setClockSpeed, speed)}
  >
    <SpeedUpSvg />
  </div>
);

const SpeedControls = props => (
  <div className={`${props.isMobile ? style.mobile : ''} ${style.wrapSpeed}`}>
    <Minus setClockSpeed={props.setClockSpeed} speed={props.speed} isMobile={props.isMobile} />
    <PlayButton
      onPlayClick={props.onPlayClick}
      playing={props.playing}
      finished={props.finished}
      isMobile={props.isMobile}
    />
    <Plus setClockSpeed={props.setClockSpeed} speed={props.speed} isMobile={props.isMobile} />
  </div>
);

/**
 * SVGeeeees
 */

const PlaySvg = () => (
  <svg width="100%" height="100%" viewBox="0 0 19.997 25.323" fill="white">
    <path id="Play" d="M12.31.625l13.013,20H0Z" transform="translate(20.622) rotate(90)" />
  </svg>
);

const PauseSvg = () => (
  <svg width="100%" height="100%" fill="white" viewBox="0 0 19.997 25">
    <g id="Pause" transform="translate(-290.111 -2845.998)">
      <rect width="6.017" height="25" transform="translate(290.111 2845.998)" />
      <rect width="6.017" height="25" transform="translate(304.091 2845.998)" />
    </g>
  </svg>
);

const ReplaySvg = () => (
  <svg role="img" width="100%" height="100%" viewBox="0 0 512 512">
    <path
      fill="currentColor"
      d="M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z"
    />
  </svg>
);

const SpeedDownSvg = () => (
  <svg stroke="white" strokeWidth="2px" width="100%" height="100%" viewBox="0 0 15 2">
    <path id="Minus" d="M0,0H15" transform="translate(0 1)" />
  </svg>
);

const SpeedUpSvg = () => (
  <svg stroke="white" strokeWidth="2px" width="100%" height="100%" viewBox="0 0 15 15">
    <path d="M0 7.5 H 15 M 7.5 0 V15" />
  </svg>
);

export default SpeedControls;
